import {
  headersMiddleware,
  overrideMiddleware,
} from '@aspectus/resource'

// import { getCookie } from '@utils/cookies'

export const HEADERS_MIDDLEWERE = headersMiddleware(overrideMiddleware({
  'Accept-Language': window.language,
  'X-Home-Request': 'test',
}))
